import {Injectable} from '@angular/core';

declare let iNet: any;
declare let $: any;

@Injectable()
export class ResourceLoaderService {

    private _loaded = [];
    private _version: string = '';

    constructor() {
        // this._initScriptVersion();
    }

    load(resources: Resource[], callback: Function) {
        if (resources.length < 1) {
            return callback();
        }
        this._loadResources(resources, callback);
    }

    loadJS(url: string, callback: Function) {
        this._loadWithTagName('script', {
            type: 'text/javascript',
            src: this.getFullUrlJS(url)
        }, callback);
    }

    loadCSS(url: string, callback: Function) {
        this._loadWithTagName('link', {
            type: 'text/css',
            rel: 'stylesheet',
            href: url
        }, callback);
    }

    getFullUrlJS(url: string) {
        if (url.indexOf('//') < 0 && iNet.fileServer) {
            if (url.startsWith('/')) {
                url = url.substr(1, url.length);
            }
            return iNet.fileServer + url;
        }
        return url;
    }

    isLoaded(url: string) {
        return this._loaded.indexOf(url) > -1;
    }

    private _loadResources(resources: Resource[], callback: Function) {
        let splitGroups = this._groupResources(resources);
        let fn = () => {
            if (splitGroups.length < 1) {
                return callback();
            }
            this._loadGroups(splitGroups.splice(0, 1)[0], fn);
        };
        fn();
    }

    //  Split group resources by sync/async
    private _groupResources(resources: Resource[]) {
        let splitGroups = [];
        let groups;

        //  Split group resources by sync/async
        for (let i = 0; i < resources.length; i++) {
            if (!groups) {
                groups = [];
                splitGroups.push(groups);
            }

            groups.push(resources[i]);

            if (resources[i].sync) {
                groups = null;
            }
        }
        return splitGroups;
    }

    private _loadGroups(resources: Resource[], callback: Function) {
        let promises = [];
        resources.forEach(item => promises.push(this._load(item)));
        Promise.all(promises).then(() => {
            callback();
        });
    }

    private _load(resource: Resource): Promise<any> {
        return new Promise((resolve) => {
            if (resource.type === 'css') {
                this.loadCSS(resource.url, resolve);
            } else {
                this.loadJS(resource.url, resolve);
            }
        });
    }

    private _loadWithTagName(tagName: string, properties, callback: Function) {
        let url = properties.src || properties.href;
        // Loaded
        if (this.isLoaded(url)) {
            return callback();
        }


        let tagEl = document.createElement(tagName);
        for (let k in properties) {
            tagEl[k] = properties[k];
        }

        tagEl.onload = () => {
            this._loaded.push(url);
            callback();
        };
        tagEl.onerror = (e) => {
            console.warn("Load resource error: " + url);
            console.warn(e);
            this._loaded.push(url);
            callback();
        };

        document.head.appendChild(tagEl);
    }

    private _initScriptVersion() {
        let $script = $('script');
        for (let i = 0; i < $script.length; i++) {
            let src = $script[i]['src'],
                index = src.indexOf('?version=');
            if (index > -1) {
                this._version = src.substr(index + 1, src.length);
                break;
            }
        }
    }
}

export interface Resource {
    url: string;
    sync?: boolean;
    loaded?: boolean;
    type?: string;
}
